// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"TablePageWrapper_tableWrapper__1Ce2u","title":"TablePageWrapper_title__3FzG-"};